import { t } from "@/i18n-js/instance";
import { useBrandedAppsBuilderFeatureFlagUI } from "@/react/hooks/useBrandedAppsBuilderUIFeatureFlag";
import { settingsNavPathV3 } from "@circle-react/helpers/urlHelpers/settingsNavPathV3";
import { NavGroup } from "../NavGroup";
import { SubNavLinkItem } from "./SubNavLinkItem";
import type { Link } from "./types";

export const BrandedAppsDashboardLinks = () => {
  const links: Link[] = [];

  const { isBrandedAppsBuilderUIEnabled } =
    useBrandedAppsBuilderFeatureFlagUI();

  const isCustomerOnCustomPlan = isBrandedAppsBuilderUIEnabled;

  // if community is not on Plus Custom plan, show the PlusLiteDashboard and the landing page
  if (!isCustomerOnCustomPlan) {
    links.push({
      label: t("settings_nav_v3.branded_apps_dashboard.lite"),
      path: settingsNavPathV3.plus.lite,
      exact: true,
    });
    links.push({
      label: t("settings_nav_v3.branded_apps_dashboard.customize"),
      path: settingsNavPathV3.plus.landing_page,
      exact: true,
    });
  }

  if (isCustomerOnCustomPlan) {
    links.push({
      label: t("settings_nav_v3.branded_apps_dashboard.customize"),
      path: settingsNavPathV3.plus.index,
      exact: true,
    });
  }

  links.push(
    {
      label: t("settings_nav_v3.branded_apps_dashboard.push_notifications"),
      path: settingsNavPathV3.plus.push_notifications,
      exact: true,
    },
    {
      label: t("settings_nav_v3.branded_apps_dashboard.billing"),
      path: settingsNavPathV3.plus.billing,
      exact: true,
    },
  );

  return (
    <NavGroup groupLinks={links}>
      <NavGroup.Content
        title={t("settings_nav_v3.branded_apps_dashboard.title")}
      >
        {links.map(link => (
          <SubNavLinkItem
            isDisabled={link.isDisabled}
            key={link.path}
            label={link.label}
            path={link.path}
          />
        ))}
      </NavGroup.Content>
    </NavGroup>
  );
};
